import React, { useState } from "react";
import { login } from "services/authService";
import { FontAwesomeIcon } from "../../node_modules/@fortawesome/react-fontawesome/index";
import { faLock, faTimes } from "../../node_modules/@fortawesome/free-solid-svg-icons/index";

const LoginModal = ({ onSuccess, onClose }) => {
  const [identifier, setIdentifier] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      await login(identifier, password);
      onSuccess();
    } catch (err) {
      setError("Wrong email or password");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.overlay} onClick={onClose}>
      <div style={styles.modal} onClick={(e) => e.stopPropagation()}>
        <button style={styles.closeButton} onClick={onClose}>
          <FontAwesomeIcon icon={faTimes} />
        </button>

        <div style={styles.header}>
          <FontAwesomeIcon icon={faLock} style={styles.lockIcon} />
          <h2 style={styles.title}>Private Collection</h2>
          <p style={styles.subtitle}>Sign in to view this content</p>
        </div>

        <form onSubmit={handleSubmit} style={styles.form}>
          <input
            type="text"
            placeholder="Email or username"
            value={identifier}
            onChange={(e) => setIdentifier(e.target.value)}
            style={styles.input}
            required
            autoFocus
          />
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            style={styles.input}
            required
          />
          {error && <p style={styles.error}>{error}</p>}
          <button type="submit" style={styles.button} disabled={loading}>
            {loading ? "Signing in..." : "Sign in"}
          </button>
        </form>
      </div>
    </div>
  );
};

const styles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0, 0, 0, 0.7)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 1000,
  },
  modal: {
    backgroundColor: "#1a1a1a",
    borderRadius: "12px",
    padding: "2rem",
    width: "90%",
    maxWidth: "380px",
    position: "relative",
    color: "#fff",
  },
  closeButton: {
    position: "absolute",
    top: "1rem",
    right: "1rem",
    background: "none",
    border: "none",
    color: "#888",
    fontSize: "1.2rem",
    cursor: "pointer",
  },
  header: {
    textAlign: "center",
    marginBottom: "1.5rem",
  },
  lockIcon: {
    fontSize: "2rem",
    color: "#888",
    marginBottom: "0.5rem",
  },
  title: {
    margin: "0.5rem 0 0.25rem",
    fontSize: "1.3rem",
    fontWeight: "600",
  },
  subtitle: {
    margin: 0,
    color: "#888",
    fontSize: "0.9rem",
  },
  form: {
    display: "flex",
    flexDirection: "column",
    gap: "0.75rem",
  },
  input: {
    padding: "0.75rem 1rem",
    borderRadius: "8px",
    border: "1px solid #333",
    backgroundColor: "#111",
    color: "#fff",
    fontSize: "1rem",
    outline: "none",
  },
  error: {
    color: "#ff4444",
    margin: 0,
    fontSize: "0.85rem",
    textAlign: "center",
  },
  button: {
    padding: "0.75rem",
    borderRadius: "8px",
    border: "none",
    backgroundColor: "#fff",
    color: "#000",
    fontSize: "1rem",
    fontWeight: "600",
    cursor: "pointer",
    marginTop: "0.25rem",
  },
};

export default LoginModal;
